import { render, staticRenderFns } from "./StrippingOperationCard.vue?vue&type=template&id=2bf0d0ed"
import script from "./StrippingOperationCard.vue?vue&type=script&lang=js"
export * from "./StrippingOperationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports